<script>
  import { pluckDataFromX, spaceLabels } from '$lib/math';
  import { selectAll } from 'd3-selection';
  import {
    partyToColour,
    partyToHoverColour,
    partyToLabel,
  } from '$lib/constants/index';
  import { valueType } from '$lib/constants/crosswalk';
  import { formatValue } from '$lib/utils';

  import { apdate } from 'journalize';

  let {
    chartheight,
    chartwidth,
    trends,
    scrubX,
    margin,
    xScale,
    yScale,
    extents,
    hoveredParty,
  } = $props();

  const lastValue = (key) => {
    const datum = trends[key];
    return datum && datum.length ? datum[datum.length - 1][1] : undefined;
  };

  const determineX = (x) => {
    if (x > margin.left && x <= chartwidth + margin.left) {
      return x || chartwidth;
    } else if (x <= chartwidth && x > 0) {
      return margin.left;
    } else {
      return margin.left + chartwidth;
    }
  };

  // where the cursor line should be (on the svg)
  const x = $derived(determineX(scrubX));

  // x value in chart coordinates ( - margin left)
  const chartX = $derived(x - margin.left);

  // nearest date to x value
  const date = $derived(xScale ? xScale.invert(chartX) : null);

  const pollData = $derived(
    pluckDataFromX({
      x: chartX,
      trends,
      xScale,
      extents,
    })
  );

  let labelG = $state();

  $effect(() => {
    if (labelG) {
      const els = selectAll('.cursor-label');
      spaceLabels({ els, pollData, yScale });
    }
  });
</script>

{#if x}
  <line
    x1={x}
    x2={x}
    y1={margin.top}
    y2={margin.top + chartheight + 8}
    stroke="#666"
    stroke-width="1"
  ></line>
  {#if date}
    <text
      {x}
      y={margin.top + chartheight + 8}
      fill="#666"
      class="date-label"
      class:hide={x < 220}>{apdate(date)}</text
    >

    <rect
      class="cursor-mask"
      fill="#ffffff"
      opacity="0.9"
      {x}
      y={margin.top}
      width={chartwidth - x + margin.left + 10}
      height={chartheight + 10}
    ></rect>
  {/if}
  <g
    transform="translate({x + 5}, {margin.top})"
    class="cursor-line-text"
    bind:this={labelG}
  >
    {#if pollData}
      {#each Object.keys(pollData) as key}
        {@const color =
          key === hoveredParty ? partyToHoverColour(key, lastValue(key)) : partyToColour(key)}
        {@const labeldata = pollData[key]}
        {#if labeldata !== null && labeldata !== undefined && (labeldata >= 10 || key === hoveredParty)}
          <g class="cursor-label" transform="translate(0, 0)" data-party={key}>
            <text x="0" y="-7.5" class="data" fill={color}>
              {formatValue(labeldata, valueType)}</text
            >
            <text x="0" y="7.5" class="party" fill={color}
              >{partyToLabel(key)}</text
            >
          </g>
        {/if}
      {/each}
    {/if}
  </g>
{/if}

<style lang="scss">
  line {
    pointer-events: none;
    stroke-dasharray: 6 5;
  }
  .cursor-label {
    pointer-events: none;
  }
  .cursor-line-text text {
    alignment-baseline: middle;
  }
  .cursor-mask {
    pointer-events: none;
  }
  .data {
    font-size: 0.9rem;
    font-weight: 800;
    @media screen and (max-width: 500px) {
      font-size: 0.8rem;
    }
  }
  .party {
    font-size: 0.8rem;
    @media screen and (max-width: 500px) {
      font-size: 0.7rem;
    }
  }
  .date-label {
    font-size: 0.9rem;
    alignment-baseline: hanging;
    text-anchor: end;
    font-size: 13px;
    &.hide {
      display: none;
    }
  }
</style>
